// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__3p5TG","range":"MonthRangeSwitch_range__3A7cA","disabled":"MonthRangeSwitch_disabled__32mvF"};